import { render } from "./EmptyLayout.vue?vue&type=template&id=4f368d20&scoped=true&lang=pug"
const script = {}

import "./EmptyLayout.vue?vue&type=style&index=0&id=4f368d20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f368d20"]])

export default __exports__